import { useTranslation } from 'react-i18next'

import { IntegrationsFilterSelect } from '../../IntegrationsFilterSelect'
import {
  QA_NAME_INTEGRATIONS_IMPORT_LOG_SOURCE,
  QA_NAME_INTEGRATIONS_IMPORT_LOG_STATUS,
} from '../IntegrationsImportLog.constants'
import {
  getImportRunSourceOptions,
  getImportRunStatusOptions,
} from '../IntegrationsImportLog.utils'

import * as styles from './IntegrationsImportLogFilters.module.css'

function IntegrationsImportLogFilters({
  source,
  status,
  onSelectSource,
  onSelectStatus,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.IntegrationsImportLogFilters}>
      <IntegrationsFilterSelect
        options={getImportRunStatusOptions(t)}
        qaName={QA_NAME_INTEGRATIONS_IMPORT_LOG_STATUS}
        value={status}
        onSelect={onSelectStatus}
      />
      <IntegrationsFilterSelect
        options={getImportRunSourceOptions(t)}
        qaName={QA_NAME_INTEGRATIONS_IMPORT_LOG_SOURCE}
        value={source}
        onSelect={onSelectSource}
      />
    </div>
  )
}

export default IntegrationsImportLogFilters
